export default "__VITE_ASSET__BQOGk6hB__"